import _extends from "@babel/runtime/helpers/esm/extends";
import { getGridColumnTypesRegistry } from "./gridColumnTypesRegistry.mjs";
export { DEFAULT_GRID_COL_TYPE_KEY } from "./gridColumnTypesRegistry.mjs";
export const getGridDefaultColumnTypes = () => _extends({}, getGridColumnTypesRegistry());